import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@docorga-v1/docorga-angular';
import { Docorga } from '@docorga-v1/docorga-common';

@Injectable()
export class PatientResource {
  private baseUri = '/prl/patients';

  constructor(private ApiService: ApiService) {}

  // GET
  findPatientsByStructureMember(): Observable<Array<Partial<Docorga.interfaces.patient.IPatientJson>>> {
    return this.ApiService.get(`${this.baseUri}/byStructureMember`);
  }

  findPatientByStructureMember(params: {
    patientId: string;
  }): Observable<Partial<Docorga.interfaces.patient.IPatientJson>> {
    return this.ApiService.get(`${this.baseUri}/${params.patientId}`);
  }

  // POST
  createPatient(params: {
    patient: Docorga.interfaces.patient.IPatientCreateJson;
  }): Observable<Partial<Docorga.interfaces.patient.IPatientJson>> {
    return this.ApiService.post(`${this.baseUri}`, params);
  }

  // PUT
  updatePatient(params: {
    patient: Docorga.interfaces.patient.IPatientJson;
  }): Observable<Docorga.interfaces.patient.IPatientJson> {
    return this.ApiService.put(`${this.baseUri}/${params.patient._id}`, params);
  }

  // DELETE
  deletePatient(params: { patientId: Docorga.interfaces.naturalTypes.NPatientObjectId }): Observable<void> {
    return this.ApiService.delete(`${this.baseUri}/${params.patientId}`);
  }
}
